import { render, staticRenderFns } from "./DescriptionCreate.vue?vue&type=template&id=9f5c7734&scoped=true&"
import script from "./DescriptionCreate.vue?vue&type=script&lang=js&"
export * from "./DescriptionCreate.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCreate.vue?vue&type=style&index=0&id=9f5c7734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5c7734",
  null
  
)

export default component.exports